<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == `${to.meta.abrev}-produto-grupo`) {
            next({ name: `${to.meta.abrev}-produto-grupo-list` });
        } else if (to.name == `grupos`) {
            next({ name: `${to.meta.abrev}-produto-grupo-list` });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == `${this.$route.meta.abrev}-produto-grupo`) {
            this.$router.push({ name: `${this.$route.meta.abrev}-produto-grupo-list` });
        }

        if (this.$route.name == `grupos`) {
            this.$router.push({ name: `${this.$route.meta.abrev}-produto-grupo-list` });
        }
    },
};
</script>
